import constrain_feature_movement from '../../../libraries/mapbox-gl-draw/src/lib/constrain_feature_movement';
import { moveFeature } from './simpleSelectModeOverride';

import MapboxGlDraw from '../../../libraries/mapbox-gl-draw/index.js';
const Constants = require('../../../libraries/mapbox-gl-draw/src/constants');

var mapboxDraw = new MapboxGlDraw();

var directSelect = mapboxDraw.options.modes.direct_select;
var baseDragVertex = directSelect.dragVertex;
var baseToDisplayFeatures = directSelect.toDisplayFeatures;
export default {
  ...directSelect,
  onSetup: function (opts) {
    return {
      ...directSelect.onSetup.call(this, opts),
      ...(opts.options || {}),
    };
  },
  dragFeature: function (state, e, delta) {
    var features = this.getSelected();
    const constrainedDelta = constrain_feature_movement(features.map(feature => feature.toGeoJSON()), delta);
    features.forEach(feature => (feature.properties.moveFeature || moveFeature)(feature, constrainedDelta));
    state.dragMoveLocation = e.lngLat;
  },
  dragVertex: (state, e, delta) => {
    if (state.feature.properties.dragVertex)
      state.feature.properties.dragVertex(state, e, delta);
    else baseDragVertex.call(this, state, e, delta)
  },
  toDisplayFeatures: function (state, geojson, push) {
    if (state.feature.properties.createSupplementaryPoints) {
      if (state.featureId === geojson.properties.id) {
        geojson.properties.active = Constants.activeStates.ACTIVE;
        push(geojson);
        var supplementaryPoints = state.feature.properties.createSupplementaryPoints(geojson);
        supplementaryPoints.forEach(push);
      } else {
        geojson.properties.active = Constants.activeStates.INACTIVE;
        push(geojson);
      }
      this.fireActionable(state);
    }
    else baseToDisplayFeatures.call(this, state, geojson, push);
  },
};